<template>
  <fieldset class="mt-3">
    <div class="row">
      <div class="col-12">
        <div class="form-check form-switch">
          <input
            id="blockthree-toggle"
            v-model="blockThree.status"
            class="form-check-input"
            type="checkbox"
            @change="$emit('toggleBlockThree')"
          />
          <label class="form-check-label" for="blockthree-toggle">Block Three</label>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6">
        <fieldset>
          <span class="card-body-title">Title</span>
          <div class="card">
            <div class="card-body">
              <div class="form-group full-width">
                <label>Text</label>
                <textarea
                  v-model="blockThree.title"
                  class="form-control mt-2"
                  required
                  rows="6"
                ></textarea>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="col-6">
        <fieldset>
          <span class="card-body-title">Description</span>
          <div class="card">
            <div class="card-body">
              <div class="form-group full-width">
                <label>Text</label>
                <textarea
                  v-model="blockThree.description"
                  class="form-control mt-2"
                  required
                  rows="6"
                ></textarea>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: "BlockThree",
  props: {
    blockThreeData: { type: Object }
  },
  data() {
    return {
      blockThree: this.blockThreeData
    };
  },
  watch: {
    blockThree: {
      handler(val) {
        this.$emit("update-blockthree", val);
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.card-footer-title {
  min-height: 285px;
}
.card-fixed {
  height: auto;
  max-height: 650px;
  overflow-y: auto;
}
.card-body {
  min-height: 250px;
}
.card-body-title {
  color: #6c757d;
  display: inline-block;
  margin-bottom: 10px;
}
.full-width {
  max-width: 100%;
  width: 100%;
  margin-top: 6px;
  margin-bottom: 6px;
}
.form-group {
  textarea {
    line-height: 20px;
  }
}
.form-switch {
  padding-left: 0;
  .form-check-input {
    margin: 0;
  }
  .form-check-label {
    cursor: pointer;
  }
}
</style>
